var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#D6DFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1667 36.1665C27.8268 36.1665 29.2156 34.983 29.5345 33.4165H22.7988C23.1179 34.983 24.5067 36.1665 26.1667 36.1665Z",
    fill: "#1E4793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5949 25.1658C32.5912 25.1658 32.5875 25.1666 32.5838 25.1666C29.0464 25.1666 26.1672 22.2882 26.1672 18.75C26.1672 17.7773 26.3909 16.8579 26.7805 16.0311C26.5787 16.0119 26.3743 16 26.1672 16C22.6234 16 19.7506 18.8727 19.7506 22.4166V24.9722C19.7506 26.7863 18.9558 28.4987 17.5615 29.6775C17.0967 30.0744 16.8905 30.7069 17.0573 31.3239C17.2517 32.0416 17.9612 32.5 18.7056 32.5H33.6243C34.4053 32.5 35.1414 31.9939 35.2999 31.2286C35.4228 30.6364 35.2119 30.0451 34.7527 29.6592C33.4198 28.5418 32.6489 26.9 32.5949 25.1658Z",
    fill: "#1E4793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7401 25.1658C19.7438 25.1658 19.7475 25.1666 19.7512 25.1666C23.2885 25.1666 26.1678 22.2882 26.1678 18.75C26.1678 17.7773 25.944 16.8579 25.5545 16.0311C25.7562 16.0119 25.9607 16 26.1678 16C29.7115 16 32.5844 18.8727 32.5844 22.4166V24.9722C32.5844 26.7863 33.3791 28.4987 34.7734 29.6775C35.2382 30.0744 35.4445 30.7069 35.2777 31.3239C35.0833 32.0416 34.3738 32.5 33.6294 32.5H18.7107C17.9297 32.5 17.1935 31.9939 17.0351 31.2286C16.9122 30.6364 17.123 30.0451 17.5823 29.6592C18.9151 28.5418 19.686 26.9 19.7401 25.1658Z",
    fill: "#1E4793"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotification);
export default __webpack_public_path__ + "static/media/NoNotification.9690508729cb694fc96642d0ee8896a8.svg";
export { ForwardRef as ReactComponent };